"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyboardControls = void 0;
var lodash_noop_1 = __importDefault(require("lodash.noop"));
function useKeyboardControls(_a) {
    var inputRef = _a.inputRef, popoverRef = _a.popoverRef, _b = _a.onEsc, onEsc = _b === void 0 ? lodash_noop_1.default : _b;
    return {
        onKeyDown: function (event) {
            var searchInput = inputRef.current;
            var container = popoverRef.current;
            var current = event.currentTarget;
            if (event.key === 'ArrowDown') {
                /**
                 * if we're currently in the lookup input,
                 * Check if we have rendered any previously saved addresses, if so, focus the FIRST child
                 * otherwise, check if we have rendered lookup results, if so, focus the FIRST child
                 */
                if (current.className.includes('address-lookup')) {
                    var previouslySavedAddresses = container === null || container === void 0 ? void 0 : container.querySelector('.previously-saved-addresses');
                    if (previouslySavedAddresses && previouslySavedAddresses.firstChild instanceof HTMLElement) {
                        previouslySavedAddresses.firstChild.focus();
                        return;
                    }
                    var lookupResults = container === null || container === void 0 ? void 0 : container.querySelector('.lookup-results');
                    if (lookupResults && lookupResults.firstChild instanceof HTMLElement) {
                        lookupResults.firstChild.focus();
                        return;
                    }
                }
                /**
                 * if we're currently on a previously saved address,
                 * Check if we have any next siblings to focus,
                 * otherwise, check if we have rendered lookup results, if so, focus the FIRST child
                 */
                if (current.hasAttribute('data-previously-saved-address')) {
                    var nextResult = current === null || current === void 0 ? void 0 : current.nextSibling;
                    if (nextResult instanceof HTMLElement) {
                        nextResult.focus();
                        return;
                    }
                    if (!nextResult) {
                        var lookupResults = container === null || container === void 0 ? void 0 : container.querySelector('.lookup-results');
                        if (lookupResults && lookupResults.firstChild instanceof HTMLElement) {
                            lookupResults.firstChild.focus();
                            return;
                        }
                        return;
                    }
                }
                /**
                 * if we're currently on a lookup result,
                 * Check if we have any next siblings to focus,
                 */
                if (current.hasAttribute('data-lookup-result')) {
                    var nextResult = current === null || current === void 0 ? void 0 : current.nextSibling;
                    if (nextResult instanceof HTMLElement) {
                        nextResult.focus();
                        return;
                    }
                }
            }
            if (event.key === 'ArrowUp') {
                /**
                 * if we're currently on a lookup result,
                 * Check if we have any previous siblings to focus,
                 * otherwise, check if we have rendered previously saved addresses, if so, focus the LAST child
                 * otherwise, go back to the lookup input
                 */
                if (current.hasAttribute('data-lookup-result')) {
                    var previousResult = current === null || current === void 0 ? void 0 : current.previousSibling;
                    if (previousResult instanceof HTMLElement) {
                        previousResult.focus();
                        return;
                    }
                    if (!previousResult) {
                        var previouslySavedAddresses = container === null || container === void 0 ? void 0 : container.querySelector('.previously-saved-addresses');
                        if (previouslySavedAddresses && previouslySavedAddresses.lastChild instanceof HTMLElement) {
                            previouslySavedAddresses.lastChild.focus();
                            return;
                        }
                        if (!previouslySavedAddresses) {
                            if (searchInput instanceof HTMLElement) {
                                searchInput.focus();
                                return;
                            }
                        }
                    }
                }
                /**
                 * if we're currently on a previously saved address,
                 * Check if we have any previous siblings to focus,
                 * otherwise, go back to the lookup input
                 */
                if (current.hasAttribute('data-previously-saved-address')) {
                    var previousResult = current === null || current === void 0 ? void 0 : current.previousSibling;
                    if (previousResult instanceof HTMLElement) {
                        previousResult.focus();
                        return;
                    }
                    if (!previousResult) {
                        if (searchInput instanceof HTMLElement) {
                            searchInput.focus();
                            return;
                        }
                    }
                }
            }
            /**
             * Close and reset the component
             */
            if (event.key === 'Escape') {
                onEsc(event);
            }
        },
    };
}
exports.useKeyboardControls = useKeyboardControls;
